// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'
import RemovedUsers from '$common/icons/removed-users'
import { openHallRemovedUsers } from '$logic/router'
import { toLocale } from '$func/text'
import { useHallRemovedSubscribersCount } from '$logic/subscription/react-hook'
import { t } from '$i18n'

const StyledListItemButton = styled(ListItemButton)`
  height: 50px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 8px 15px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 15px;
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
  },
}))

const StyledSecondaryListItemText = styled(ListItemText)(({ theme }) => ({
  flex: 'none',
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
    color: theme.palette.secondary.main,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  hallId: string
}

export function HallRemovedUsersProfileActionItem({ hallId }: Props) {
  const { count, loading } = useHallRemovedSubscribersCount(hallId)

  return (
    <>
      <StyledListItem onClick={() => openHallRemovedUsers(hallId)}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon>
            <RemovedUsers sx={{ color: 'secondary.main' }} />
          </StyledListItemIcon>
          <StyledListItemText>
            {t('profile.hall.actions.removedUsers')}
          </StyledListItemText>

          {loading ? (
            <Skeleton sx={{ minWidth: '25px' }} />
          ) : count ? (
            <StyledSecondaryListItemText>
              {toLocale(count)}
            </StyledSecondaryListItemText>
          ) : null}
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}
